
const TableSkeleton = ({ columns = 5, rows = 8 }) => (
  <div className="table-responsive">
    <table className="table mb-0">
      <thead className="table-light">
        <tr>
          {Array.from({ length: columns }).map((_, i) => (
            <th key={i} className="py-3">
              <div className="skeleton-bar" style={{ width: '50%', height: '14px' }} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <td key={colIndex} className="py-3">
                <div className="skeleton-bar" style={{ 
                  width: colIndex === 0 ? '70%' : '90%', 
                  height: '16px',
                  borderRadius: '4px' 
                }} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    <style>{`
      .skeleton-bar {
        background: #eee;
        background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
        background-size: 200% 100%;
        animation: 1.5s shine linear infinite;
      }
      @keyframes shine {
        to { background-position-x: -200%; }
      }
    `}</style>
  </div>
);

const styles = `
  .skeleton-item {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    opacity: 0.7;
  }
  
  @keyframes skeleton-loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  
  .skeleton-row td { vertical-align: middle; }
`;

if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = styles;
  document.head.appendChild(style);
}

export default TableSkeleton;
